import bgLines from '../../assets/login/login_bg.png'
import { useEffect } from 'react';

interface ApplicationBackgroundProps {
    onImageLoad?: () => void;
}

export const ApplicationBackground = ({ onImageLoad }: ApplicationBackgroundProps) => {
    useEffect(() => {
        // Preload the background image
        const img = new Image();
        img.src = bgLines;
        
        img.onload = () => {
            if (onImageLoad) {
                onImageLoad();
            }
        };

        img.onerror = () => {
            // Even if image fails to load, show the content
            if (onImageLoad) {
                onImageLoad();
            }
        };

        // Cleanup
        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [onImageLoad]);

    return (
        <div className="">
            {/* 🌫 Background Layer (SVG Image + Blur) */}
            <div
                className="fixed inset-0 z-0 bg-fixed"
                style={{
                    backgroundImage: `url(${bgLines})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                }}
            >
                {/* SVG 1: Top right blue blur */}
                <svg
                    className="fixed right-[15%] sm:right-[25%] top-0"
                    width="672"
                    height="382"
                    viewBox="0 0 672 382"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_f_222_530)">
                        <ellipse cx="336" cy="51.5" rx="236" ry="230.5" fill="#0081BC" fillOpacity="0.1" />
                    </g>
                    <defs>
                        <filter
                            id="filter0_f_222_530"
                            x="0"
                            y="-279"
                            width="672"
                            height="661"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_222_530" />
                        </filter>
                    </defs>
                </svg>

                {/* SVG 2: Pink left blur — responsive positioning */}
                <svg
                    className="fixed left-0 sm:left-0 top-[20%] sm:top-[20%]"
                    width="193"
                    height="542"
                    viewBox="0 0 193 542"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_f_357_7216)">
                        <ellipse cx="-95" cy="271" rx="188" ry="171" fill="#FF7CED" fillOpacity="0.16" />
                    </g>
                    <defs>
                        <filter
                            id="filter0_f_357_7216"
                            x="-383"
                            y="0"
                            width="576"
                            height="542"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_357_7216" />
                        </filter>
                    </defs>
                </svg>

                {/* SVG 3: Yellow blur — responsive positioning */}
                <svg
                    className="fixed left-[5%] sm:left-[10%] top-[35%] sm:top-[35%]"
                    width="574"
                    height="561"
                    viewBox="0 0 574 561"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_f_323_1097)">
                        <ellipse cx="287" cy="280.5" rx="187" ry="180.5" fill="#FFE28C" fillOpacity="0.2" />
                    </g>
                    <defs>
                        <filter
                            id="filter0_f_323_1097"
                            x="0"
                            y="0"
                            width="574"
                            height="561"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_323_1097" />
                        </filter>
                    </defs>
                </svg>

                {/* SVG 4: Green blur — responsive positioning */}
                <svg
                    className="fixed left-[40%] sm:left-[50%] top-[25%] sm:top-[25%]"
                    width="453"
                    height="444"
                    viewBox="0 0 453 444"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_f_323_1098)">
                        <ellipse cx="226.5" cy="222" rx="126.5" ry="122" fill="#A7DA64" fillOpacity="0.2" />
                    </g>
                    <defs>
                        <filter
                            id="filter0_f_323_1098"
                            x="0"
                            y="0"
                            width="453"
                            height="444"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_323_1098" />
                        </filter>
                    </defs>
                </svg>
            </div>
        </div>
    )
}
